export { default } from './Titol';
